<template>
  <div class="basis-[22rem] text-center my-1 mr-2">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>
